var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"viewBox":"0 0 24 24","width":"20px","height":"20px"}},[_c('path',{attrs:{"d":"M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z","fill":"#3399ff"}})])}
var staticRenderFns = []

export { render, staticRenderFns }